import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export const PageBreadcrumb = ({ items }) => {
  // items = [{ label: 'Калкулатор', href: '/calculator' }]
  const all = [{ label: 'Начало', href: '/' }, ...items];

  return (
    <nav aria-label="breadcrumb" className="max-w-6xl mx-auto px-4 sm:px-6 pt-4 pb-0">
      <ol className="flex items-center gap-1 text-sm text-slate-400 dark:text-slate-500 flex-wrap">
        {all.map((item, i) => {
          const isLast = i === all.length - 1;
          return (
            <li key={item.href} className="flex items-center gap-1">
              {i === 0 && <Home className="w-3.5 h-3.5 flex-shrink-0" />}
              {isLast ? (
                <span className="font-medium text-gray-600 dark:text-gray-400" aria-current="page">{item.label}</span>
              ) : (
                <Link to={item.href} className="hover:text-gray-700 dark:hover:text-gray-300 transition-colors duration-150">
                  {item.label}
                </Link>
              )}
              {!isLast && <ChevronRight className="w-3.5 h-3.5 flex-shrink-0 text-slate-300 dark:text-slate-600" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
